import { cn } from "@ui/utils"

import { Link } from "@/components/book-link"

import { BaseInlineInput } from "./base"
import { InlineInputProps } from "./props"

export interface ReadonlyAttributeProps extends InlineInputProps {
  href?: string
}

export function ReadonlyAttribute({
  label,
  LabelIcon,
  value,
  placeholder = "Not configured",
  hideLabel,
  href,
  size,
  fixedLabelWidth,
  renderValue,
  className,
}: ReadonlyAttributeProps) {
  const effectiveRenderValue = renderValue
    ? renderValue
    : (effectiveValue: string) => {
        if (href && effectiveValue && typeof effectiveValue === "string") {
          return href.startsWith("http") ? (
            <a
              href={href}
              className="text-link hover:text-link-hover max-w-sm truncate underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              {effectiveValue}
            </a>
          ) : (
            <Link href={href} className="text-link hover:text-link-hover max-w-sm truncate underline">
              {effectiveValue}
            </Link>
          )
        }

        return value ?? placeholder
      }

  return (
    <BaseInlineInput
      label={label}
      LabelIcon={LabelIcon}
      hideLabel={hideLabel}
      fixedLabelWidth={fixedLabelWidth}
      size={size}
      className={className}
    >
      <div className="w-full">
        <div
          className={cn(
            "bg-background flex min-h-6 w-full items-center rounded-md border border-transparent px-2",
            size !== "lg" ? "text-sm" : "text-base leading-[1.4]"
          )}
        >
          {effectiveRenderValue(value ?? "")}
        </div>
      </div>
    </BaseInlineInput>
  )
}
